import restClient from "./restClient";
import { TestCase, ValimateResponseDto } from "../autogenerated/models";

export const generateTestRequestPayload = () =>
  restClient.get<string>("/api/valimate/GeneraTetestRequestPayload");

export const callValimate = (payload: string) =>
  restClient.post<ValimateResponseDto>("/api/valimate/CallValimate", payload);

export const fetchStatus = (testCaseId: string) =>
  restClient.get<ValimateResponseDto>(`/api/valimate/getstatus/${testCaseId}`);

export const GetTestCasesCache = () =>
  restClient.get<Array<TestCase>>(`/api/Admin/GetTestCasesCache`, undefined, { rejectOnError: true });

export const RebuildTestCasesCache = () =>
  restClient.get<any>(`/api/Admin/RebuildTestCasesCache`, undefined, { rejectOnError: true });

export const RestoreTestCasesCache = () =>
  restClient.get<any>(`/api/Admin/RestoreTestCasesCache`, undefined, { rejectOnError: true });

export const UpdateTestCasesModel = (payload: Array<TestCase>) =>
  restClient.post<Array<TestCase>>("/api/Admin/UpdateTestCasesModel", {
    testCases: payload,
  });
